<div id="selectbox" style="width: 515px;" class="ml-23">
    <dx-select-box
        [dataSource]="dataSource"
        displayExpr="name"
        valueExpr="id"
        [searchMode]="searchModeOption"
        [searchExpr]="searchExprOption"
        [searchTimeout]="searchTimeoutOption"
        [minSearchLength]="minSearchLengthOption"
        [searchEnabled]="true"
        [showDataBeforeSearch]="showDataBeforeSearchOption"
        [(ngModel)]="value"
        (ngModelChange)="onValueChanged($event)"
        [disabled]="disabled" 
        [(required)]="isRequired">
    </dx-select-box>
</div>
